import { deepCopy } from '../utils';
import { GET_LATEST_WAREHOUSE_PRINT_JOB } from '../../../common/graphql/warehousePrintJob';

const createQueuedJob = ({ variables, queueEntry }) => ({
	__typename: 'WarehousePrintJob',
	id: `offline-${queueEntry.id}`,
	operationId: variables.operationId,
	serviceDocketId: variables.serviceDocketId || null,
	labelType: variables.labelType || null,
	isReprint: Boolean(variables.jobId),
	status: 'QUEUED',
	statusMessage: 'Queued on this phone. It will be sent when the phone reconnects.',
	created: new Date(queueEntry.createdAt).toISOString(),
	warehouse: null,
});

const warehousePrintJobConfig = {
	queueOnNetworkError: true,
	serializeVariables: ({ variables }) => deepCopy(variables),
	createMeta: ({ variables, context }) => ({
		type: variables.jobId ? 'reprintWarehouseLabel' : 'createWarehouseLabel',
		serviceDocketId: variables.serviceDocketId || context?.warehousePrint?.serviceDocketId || null,
		labelType: variables.labelType || context?.warehousePrint?.labelType || null,
		jobId: variables.jobId || null,
	}),
	getOfflineResult: ({ variables, queueEntry }) => {
		const queuedJob = createQueuedJob({ variables, queueEntry });
		return {
			createWarehousePrintJob: queuedJob,
			reprintWarehousePrintJob: queuedJob,
		};
	},
	onSuccess: ({ client, result }) => {
		const job = result?.data?.createWarehousePrintJob || result?.data?.reprintWarehousePrintJob;
		if (!job?.serviceDocketId || !job?.labelType) {
			return;
		}
		client.writeQuery({
			query: GET_LATEST_WAREHOUSE_PRINT_JOB,
			variables: {
				serviceDocketId: job.serviceDocketId,
				labelType: job.labelType,
			},
			data: {
				latestWarehousePrintJob: job,
			},
		});
	},
};

export default warehousePrintJobConfig;
